module.exports = __webpack_public_path__ + "static/media/desktopScreenshot03.a58c0552.jpg";